import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';

const Hero: React.FC = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  const content = {
    en: {
      title: "Enhance Your Natural Beauty",
      subtitle: "Experience the best in aesthetic treatments to rejuvenate and restore your skin's natural radiance",
      cta: "Book Appointment"
    },
    da: {
      title: "Fremhæv din naturlige skønhed",
      subtitle: "Oplev de bedste æstetiske behandlinger til at forynge og genoprette din huds naturlige glød",
      cta: "Book tid"
    }
  };

  const handleBooking = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/book');
  };

  return (
    <section className="relative min-h-screen bg-[#F5F0EC]" id="home">
      <div className="max-w-[1400px] mx-auto px-6 min-h-screen grid grid-cols-1 lg:grid-cols-2 items-center">
        {/* Left Column - Text */}
        <div className="pt-32 lg:pt-0 z-10 md:max-w-xl">
          <div className="overflow-hidden">
            <h2 
              className="text-[2.5rem] sm:text-[3.5rem] lg:text-[4.5rem] font-serif leading-[1.1] mb-6 transition-transform duration-500 ease-out"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {content[language].title}
            </h2>
          </div>
          
          <div className="overflow-hidden">
            <p className="text-lg text-black/80 mb-8 max-w-md transition-transform duration-500 ease-out delay-100">
              {content[language].subtitle}
            </p>
          </div>
          
          <button 
            onClick={handleBooking}
            className="inline-block px-8 py-3 bg-[#A68B7C] text-white rounded-md text-sm tracking-wide 
                     hover:bg-[#95796A] transition-all duration-300 hover:scale-[1.02] hover:shadow-md"
          >
            {content[language].cta}
          </button>
        </div>

        {/* Right Column - Image */}
        <div className="absolute top-0 right-0 w-full lg:w-1/2 h-screen lg:relative">
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/30 lg:hidden" />
          <img
            src="https://images.pexels.com/photos/3373716/pexels-photo-3373716.jpeg"
            alt="Beauty Treatment"
            className="w-full h-full object-cover transition-opacity duration-700"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;